import styled, { css } from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import CitySelection from '@ertelecom/ui-react/components/popups/citySelection';
import { CollapsedMenu, TopMenuItem, breakpoints } from '~/src/components/Header/styled';

export const RightMenu = styled.div`
    margin-left: auto;
    position: relative;

    @media(max-width: ${breakpoints.sDesktop}) {
        margin-left: 0;
        justify-content: center;
    }
`;

export const MenuItem = styled(TopMenuItem)<{ isPromoted?: boolean }>`
    @media (max-width: ${breakpoints.sDesktop}) {
        ${p => p.isPromoted && css`
            a {
                color: ${COLORS.red};
            }

            &:before {
                content: '';
                position: absolute;
                left: 1px;
                top: 17px;
                width: 11px;
                height: 9px;
                background: url('${require('~/static/images/menu/promo.svg')}') no-repeat;
                background-size: cover;
            }
        `}
    }
`;

export const CitySelect = styled(TopMenuItem)`
    color: ${COLORS.blue};
    cursor: pointer;

    @media(max-width: ${breakpoints.sDesktop}) {
        display: none;
    }
`;

export const RightCollapsedMenu = styled(CollapsedMenu)`
    white-space: nowrap;
    justify-content: flex-end;
    left: auto;
    right: -16px;
    transform: translate(0, 0);
`;

export const BlockForCitySelection = styled.div`
    position: absolute;
    right: 0;
    top: -30px;
`;

export const CitySelectionCustom = styled(CitySelection)`
    position: relative;
    pointer-events: auto;
    z-index: 20;
`;
